import React from "react";
import ThreeDSceneWrapper from "./components/ThreeDSceneWrapper";

function App() {
  return (
    <div className="min-h-screen bg-black h-full text-gray-100">
      <main className="w-full h-screen">
        <ThreeDSceneWrapper />
      </main>
    </div>
  );
}

export default App;
